module.exports = __webpack_public_path__ + "static/img/yeswecan0033.63782b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/yeswecan0033.png
// module id = 608
// module chunks = 1